import $ from "cash-dom"
import signals from "signals"
import {is_visible} from "dom_utils"
import rollbar_helper from "rollbar_helper"

let page_sections_collector
let page_sections = []
const observers = []

let initial_mobile_middlebar_title = null

// It collects the sections of the page and sets its active state depending if
// it is in the viewport or not. You can register a callback to get notified
// about any change of them
export default page_sections_collector = {
  init: () => {
    initial_mobile_middlebar_title = $("[data-toggle-sidebar] > span").text()
    page_sections_collector.create()
    listen_to_filter_manager()
    listen_to_scroll_event()
  },
  create: () => {
    collect_page_sections()
    return page_sections_collector.update()
  },

  update: () => {
    const active_section = find_current_active_section(page_sections)
    return observers.map((observer) => observer(page_sections, active_section))
  },

  register: (observer) => {
    observers.push(observer)
    // sent data immediately once when it already exists
    if (page_sections) return observer(page_sections)
  }
}

// create a list of page sections with sub sections
// based on the section elements inside the document
const collect_page_sections = () => {
  page_sections = []
  // only use sections that are visible/not filtered
  $("section").each(function() {
    if (!is_visible(this)) return
    const $section = $(this)
    const section_id = $section.attr("id")
    if (!section_id) return
    const $heading = $section.find("h2, h3").first()
    const title = $section.data("title") || $heading.text().trim()
    // sections without a heading count as top level heading as well
    if ($heading.is("h2") || !$heading.length) {
      return page_sections.push({id: section_id, title, children: []})
    }

    const last_page_section = page_sections[page_sections.length - 1]
    if (last_page_section) {
      return last_page_section.children.push({id: section_id, title})
    }

    rollbar_helper.send_error_msg(`Page section doesn't have parent: ${title}`)
  })
}

// set current section active
// if the viewport is intersecting with its related section
const find_current_active_section = (sections) => {
  if (!sections?.length) return
  const scroll_pos = _get_scroll_position()
  let active_section
  for (let index = 0; index < sections.length; index++) {
    const section = sections[index]
    section.is_active = false
    if (is_viewport_in_section(section, sections[index + 1], scroll_pos)) {
      section.is_active = true
      active_section = find_current_active_section(
        section.children,
        scroll_pos
      )
      active_section = active_section || section
    }
  }
  return active_section
}

// Sometimes sections aren't directly connected and are separated with a margin.
// We add an offset in case the viewport is directly located on that gap between
// two sections.
const is_viewport_in_section = (section, next_section, scroll_pos) => {
  if (next_section && is_viewport_in($(`#${next_section.id}`), scroll_pos)) {
    return false
  }
  return is_viewport_in($(`#${section.id}`), scroll_pos, 50)
}

const is_viewport_in = ($el, scroll_pos, height_offset = 0) => {
  if (!$el.length) return false
  const top_distance = $el.offset().top
  const height = $el.height() + height_offset
  return top_distance <= scroll_pos && top_distance + height > scroll_pos
}

const _get_scroll_position = () => {
  // add middlebar height because it is sticky at the top of the screen
  let pos =
    window.scrollY +
    _middlebar_height() +
    ready_to_learn_banner_height()
  // adding 1px because there can be a rounding difference between
  // the current scroll position and the target offset
  return (pos += 1)
}

const _middlebar_height = () => $(".middlebar").height() || 0

// we take its height directly even though it is bigger initially
// because we adjust the scroll after a timeout
const ready_to_learn_banner_height = () =>
  document.querySelector(".ready-to-learn-banner")?.offsetHeight || 0

// updates sidebar when content was filtered
const listen_to_filter_manager = () =>
  signals.on("kenhub.filter_manager_filtered", page_sections_collector.create)

const listen_to_scroll_event = () =>
  $(document).on("scroll", page_sections_collector.update)
